/** Turn CMS HTML (TinyMCE / pasted tags) into a single plain-text quote. */
export function stripHtml(value) {
  const raw = String(value || '');
  if (!raw.trim()) {
    return '';
  }

  const normalized = raw
    .replace(/<\s*br\s*\/?>/gi, ' ')
    .replace(/<\/(p|div|li|h[1-6])>/gi, ' ');

  let text = normalized;
  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(normalized, 'text/html');
    text = doc.body?.textContent || '';
  } else {
    text = normalized.replace(/<[^>]+>/g, ' ');
  }

  return text
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function socialFromUrl(url) {
  let href = String(url || '').trim();
  if (!href) {
    return null;
  }
  if (!/^https?:\/\//i.test(href)) {
    href = `https://${href}`;
  }

  const lower = href.toLowerCase();
  if (lower.includes('youtu')) {
    return { href, icon: 'fab fa-youtube', label: 'Watch on YouTube' };
  }
  if (lower.includes('instagram')) {
    return { href, icon: 'fab fa-instagram', label: 'Watch on Instagram' };
  }
  if (lower.includes('tiktok')) {
    return { href, icon: 'fab fa-tiktok', label: 'Watch on TikTok' };
  }
  if (lower.includes('facebook') || lower.includes('fb.watch') || lower.includes('fb.com')) {
    return { href, icon: 'fab fa-facebook-f', label: 'Watch on Facebook' };
  }
  if (lower.includes('vimeo')) {
    return { href, icon: 'fab fa-vimeo-v', label: 'Watch on Vimeo' };
  }

  return { href, icon: 'fas fa-play', label: 'Watch review' };
}

export function formatTourDate(value) {
  if (!value) {
    return '';
  }
  const raw = String(value);
  const d = new Date(raw.includes('T') ? raw : `${raw}T00:00:00`);
  if (Number.isNaN(d.getTime())) {
    return raw;
  }
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function departureLabel(dep) {
  if (!dep) {
    return '';
  }
  const start = formatTourDate(dep.start_date);
  const end = dep.end_date && dep.end_date !== dep.start_date ? formatTourDate(dep.end_date) : '';
  const range = end ? `${start} – ${end}` : start;
  return dep.label ? `${dep.label} · ${range}` : range;
}

/** Display price from API (range when packages exist). */
export function tourPriceDisplay(tour) {
  if (!tour) {
    return '';
  }
  return String(tour.price || '').trim();
}

export function tourHasPackages(tour) {
  if (!tour) {
    return false;
  }
  if (tour.has_packages) {
    return true;
  }
  return Array.isArray(tour.packages) && tour.packages.length > 0;
}
